import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import 'antd/dist/reset.css';
import "./index.css";
import "./i18n";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import MainLayout from "./layouts";
import ContinueOnAnotherDevice from "./pages/continue-on-another-device";
import ContinueOnAnotherDeviceEmail from "./pages/continue-on-another-device-email";
import ContinueOnAnotherDeviceSms from "./pages/continue-on-another-device-sms";
import CheckYourDevice from "./pages/check-your-device";
import TakeAPhoto from "./pages/take-a-photo";
import ConfirmPhoto from "./pages/confirm-photo";
import ProcessingId from "./pages/processing-id";
import Fail from "./pages/fail";
import Success from "./pages/success";
import Processing from "./pages/processing";
import ProcessingReview from "./pages/processing-review";
import LivenessCheckStart from "./pages/lc-start";
import LivenessCheck from "./pages/lc";
import TestButtonPage from "./pages/test-page";
import "react-phone-number-input/style.css";
import Verification from "./pages/verification";
import ProtectedRoutes from "./components/ProtectedRoutes";
import Selfie from "./pages/selfie";
import {
  FpjsProvider
} from '@fingerprintjs/fingerprintjs-pro-react'
import GettingStarted from "./pages/getting-started";
import VerificationChoose from "./pages/verification-choose";
import ConfirmEmail from "./pages/confirm-email";
import EmailVerification from "./pages/email-verification";
import EidVerification from "./pages/eid-verification";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";
import KyxClientForm from "./pages/client-form";
import PhoneVerification from "./pages/phone-verification";
import ConfirmPhone from "./pages/confirm-phone";
import NotFound from "./pages/not-found";
import SelectCountry from "./pages/select-country";
import LinkExpired from "./pages/link-expired";
import CheckLink from "./pages/check-link";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import AddressVerification from "./pages/address-verification";
import StepIterator from "./pages/step-iterator";
import SpoofError from "./pages/spoof";
import Decline from "./pages/decline";
import NoCameraError from "./pages/error-no-camera";
import CameraAccessError from "./pages/error-access-camera";
import BankVerification from "./pages/bank-verification";
import ErrorPage from "./pages/error-page";
import BankError from "./pages/error-bank";
import Final from "./pages/final";
import LocationVerification from "./pages/location-verification";
import AddressConfirmation from "./pages/address-confirmation";
import FileUploadPage from "./pages/file-upload";
import AntdConfigProvider from "./providers/antd-config-provider";
import TakeAPhotoWithOnnx from "./pages/take-a-photo-with-onnx";
import { shouldUseOnnxModel } from "./utils/deviceDetector";
import logger from "./utils/logger";

const TakeAPhotoRouter = () => {
  const useOnnx = shouldUseOnnxModel();

  useEffect(() => {
    logger.log('TakeAPhotoRouter: Using ONNX model:', useOnnx);
  }, [useOnnx]);

  return useOnnx ? <TakeAPhotoWithOnnx /> : <TakeAPhoto />;
};

export const router = createBrowserRouter([
  {
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: <GettingStarted />,
      },
      {
        element: <ProtectedRoutes />,
        children: [
          {
            path: "next",
            element: <StepIterator />,
          },
          {
            path: "verification-choose",
            element: <VerificationChoose />,
          },
          {
            path: "verification",
            element: <Verification />,
          },
          {
            path: "continue-on-another-device",
            element: <ContinueOnAnotherDevice />,
          },
          {
            path: "continue-on-another-device-email",
            element: <ContinueOnAnotherDeviceEmail />,
          },
          {
            path: "continue-on-another-device-sms",
            element: <ContinueOnAnotherDeviceSms />,
          },
          {
            path: "check-your-device",
            element: <CheckYourDevice />,
          },
          {
            path: "selfie",
            element: <Selfie />,
          },
          {
            path: "select-country",
            element: <SelectCountry />,
          },
          {
            path: "take-a-photo",
            element: <TakeAPhotoRouter />,
          },
          {
            path: "take-a-photo-with-onnx",
            element: <TakeAPhotoWithOnnx />,
          },
          {
            path: "confirm-photo",
            element: <ConfirmPhoto />,
          },
          {
            path: "processing-id",
            element: <ProcessingId />,
          },
          {
            path: "fail",
            element: <Fail />,
          },
          {
            path: "success",
            element: <Success />,
          },
          {
            path: "final",
            element: <Final />,
          },
          {
            path: "processing",
            element: <Processing />,
          },
          {
            path: "processing-review",
            element: <ProcessingReview />,
          },
          {
            path: "lc-start",
            element: <LivenessCheckStart />,
          },
          {
            path: "lc",
            element: <LivenessCheck />,
          },
          {
            path: "email-verification",
            element: <EmailVerification />,
          },
          {
            path: "eid-verification",
            element: <EidVerification />,
          },
          {
            path: "confirm-email",
            element: <ConfirmEmail />,
          },
          {
            path: "client-form",
            element: <KyxClientForm />,
          },
          {
            path: "phone-verification",
            element: <PhoneVerification />,
          },
          {
            path: "confirm-phone",
            element: <ConfirmPhone />,
          },
          {
            path: "address-verification",
            element: <AddressVerification />,
          },
          {
            path: "bank-verification",
            element: <BankVerification />,
          },
          {
            path: "file-upload",
            element: <FileUploadPage />,
          },
          {
            path: "location-verification",
            element: <LocationVerification />,
          },
          {
            path: "address-confirmation",
            element: <AddressConfirmation />,
          },
          {
            path: "test-page",
            element: <TestButtonPage />,
          },
          {
            path: "error-access-camera",
            element: <CameraAccessError />,
          },
          {
            path: "error-no-camera",
            element: <NoCameraError />,
          },
          {
            path: "error-bank",
            element: <BankError />,
          },
          {
            path: "link-expired",
            element: <LinkExpired />,
          },
          {
            path: "check-link",
            element: <CheckLink />,
          },
          {
            path: "not-found",
            element: <NotFound />,
          },
          {
            path: "spoof",
            element: <SpoofError />,
          },
          {
            path: "decline",
            element: <Decline />,
          },
          {
            path: "error-page",
            element: <ErrorPage />,
          },
          {
            path: "*",
            element: <NotFound />,
          },
        ],
      },
    ],
  },
  {
    path: "/health",
    element: <h3>The App is Healthy</h3>,
  },
  {
    path: "*",
    element: <p>Path not resolved</p>,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <FpjsProvider
      loadOptions={{
        apiKey: `${window.__ENV__?.REACT_APP_FINGER_PRINT_API_KEY}`,
        region: "eu",
        endpoint: "https://metrics.kyxplatform.com",
        scriptUrlPattern: `https://metrics.kyxplatform.com/web/v3/${window.__ENV__?.REACT_APP_FINGER_PRINT_API_KEY}/loader_v3.9.3.js`
      }}
    >
      <AntdConfigProvider
      >
        <RouterProvider router={router}></RouterProvider>
      </AntdConfigProvider>
    </FpjsProvider>
    <ToastContainer />
  </>
);
